import {
  GET_ADMISSION_FORM_LOOKUPS,
  GET_DEGREE_REGISTRATION_DETAILS_BY_STUDENTID,
  GET_ENTRANCE_EXAMINATION_DETAILS_BY_STUDENTID,
  GET_EXPERIENCEDETAILS_BY_STUDENTID,
  GET_INTERNSHIPDETAILS_BY_STUDENTID,
  GET_NEET_DETAILS_BY_STUDENTID
} from "../actions/types";

const initialState = [];

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_EXPERIENCEDETAILS_BY_STUDENTID:
      return action.payload;
    default:
      return state;
  }
}

export const internshipDetails = (state = initialState, action) => {
  switch (action.type) {
    case GET_INTERNSHIPDETAILS_BY_STUDENTID:
      return action.payload;
    default:
      return state;
  }
};

export const entranceExaminationDetails = (state = initialState, action) => {
  switch (action.type) {
    case GET_ENTRANCE_EXAMINATION_DETAILS_BY_STUDENTID:
      return action.payload;
    default:
      return state;
  }
};

export const degreeRegistrationDetails = (state = [], action) => {
  switch (action.type) {
    case GET_DEGREE_REGISTRATION_DETAILS_BY_STUDENTID:
      return action.payload;
    default:
      return state;
  }
};

export const neetDetails = (
  state = {
    Id: 0,
    rollNo: "",
    allIndiaRank: 0,
    applicationNo: "",
    neetScore: 0,
    IsDelete: 0
  },
  action
) => {
  switch (action.type) {
    case GET_NEET_DETAILS_BY_STUDENTID:
      return action.payload;
    default:
      return state;
  }
};

export const admissionFormLookups = (state = [], action) => {
  switch (action.type) {
    case GET_ADMISSION_FORM_LOOKUPS:
      return action.payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/getExperienceDetailsByStudentId.js